function getAuth0LoginUrl() {
  const returnToUrl = `${window.xrealShopUrl}/pages/redirect`;
  const redirectUrl = `${window.xrealShopUrl}/pages/redirect?pass=unpass`;
  const auth0LoginURL = `${window.auth0Settings.auth0_domain}/authorize?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&return_to=${encodeURIComponent(returnToUrl)}&scope=SCOPE&state=STATE&redirect_uri=${encodeURIComponent(redirectUrl)}`;
  console.log('auth0 Login url', auth0LoginURL)
  return auth0LoginURL;
}

function getAuth0LogoutUrl() {
  let returnToUrl = `${window.xrealShopUrl}/account/logout`;
  if (`${window.routes.root_url}`.length > 1) {
    returnToUrl = `${window.xrealShopUrl}${window.routes.root_url}/account/logout`;
  }
  const auth0LogoutURL = `${window.auth0Settings.auth0_domain}/v2/logout?response_type=code&client_id=${window.auth0Settings.auth0_client_id}&returnTo=${encodeURIComponent(returnToUrl)}`;
  console.log('auth0 Logout url', auth0LogoutURL)
  return auth0LogoutURL;
}

function goToAuth0({ action = 'login' }) {
  const logoutURL = getAuth0LogoutUrl();
  const loginURL = getAuth0LoginUrl();
  const auth0URL = action === 'login' ? loginURL : logoutURL;
  if (action === 'logout') {
    localStorage.removeItem('xreal-uid');
  }
  try {
    window.location.href = auth0URL;
  } catch (error) {
    console.error('Failed to navigate to Auth0 logout URL:', error);
  }
}

function getCurrentProduct() {
  let productTitle = '';
  const xCurrentProduct = document.querySelector(".product__title h1");
  if (xCurrentProduct) {
    productTitle = xCurrentProduct.textContent.trim();
  }
  return productTitle;
}

// 记录跳转登录前的页面
const XCurrentURL = window.location.href;
const xUrlParams = new URLSearchParams(window.location.search);
if (XCurrentURL.includes('login')) {
  if (xUrlParams.has('checkout_url')) {
    let checkoutUrl = xUrlParams.get('checkout_url');
    checkoutUrl = `${window.xrealShopUrl}${checkoutUrl}`;
    localStorage.setItem('xreal-currentURL', checkoutUrl);
  }
} else if (!XCurrentURL.includes('redirect')) {
  localStorage.setItem('xreal-currentURL', XCurrentURL);
}

async function getHashString36(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
  return base64Hash.slice(0, 36);
}

function parsePrice(priceStr) {
  // 正则解析：分离前缀币种、数字部分、后缀币种
  const regex = /([^\d\s,.]+)?[\s]*([\d.,]+)[\s]*([A-Z]{3})?/;
  const match = priceStr.match(regex);

  if (match) {
    let prefixCurrency = match[1]?.trim() || ''; // 前缀币种
    const rawNumber = match[2]; // 原始数字部分
    const suffixCurrency = match[3] || ''; // 后缀币种

    // 处理数字部分
    const normalizedNumber = rawNumber.replace(/,/g, ''); // 去掉千位分隔符
    const amount = parseFloat(normalizedNumber).toFixed(2); // 保留两位小数

    // 确定币种
    let currency = suffixCurrency || prefixCurrency;

    // 特殊处理前缀币种的转换
    const currencyMap = {
      '$': 'USD',
      'HK$': 'HKD',
      '€': 'EUR',
      '¥': 'JPY'
    };
    currency = currencyMap[currency] || currency;

    return {
      currency,
      amount,
    };
  } else {
    return {
      currency: '',
      amount: '0.00',
    };
  }
}

/**
  * 检测单个模块定时上下线时间（announcement用这个）
  * @param {HTMLElement} el
  */
function handleTimeVisibility(el) {
  const startStr = el.dataset.start || '1970-01-01T00:00:00';
  const endStr = el.dataset.end || '9999-12-31T23:59:59';
  const tz = el.dataset.timezone || 'UTC';
  const now = luxon.DateTime.now().setZone(tz);
  const start = luxon.DateTime.fromISO(startStr, { zone: tz });
  const end = luxon.DateTime.fromISO(endStr, { zone: tz });

  if (start.isValid && end.isValid) {
    if (now >= start && now < end) {
      el.style.display = '';
      el.removeAttribute('data-timed-hidden');
      return true;
    } else {
      el.style.display = 'none';
      el.setAttribute('data-timed-hidden', '');
      return false;
    }
  } else {
    console.warn(`Invalid time range: start=${startStr}, end=${endStr}, tz=${tz}`);
    el.style.display = 'none';
    el.setAttribute('data-timed-hidden', '');
    return false;
  }
}

function checkTimeVisible(sectionClass, slideItemClass) {
  const section = document.querySelector(sectionClass);
  const sectionVisible = handleItemTimeVisible(slideItemClass);
  if (!sectionVisible) {
    section.style.display = 'none';
  }
}

function handleItemTimeVisible(slideItemClass) {
  let visible = false;
  const { DateTime } = luxon;
  document.querySelectorAll(slideItemClass).forEach((slideBlock) => {
    const startStr = slideBlock.dataset.start || '1970-01-01T00:00:00';
    const endStr = slideBlock.dataset.end || '9999-12-31T23:59:59';
    const tz = slideBlock.dataset.timezone;
    const now = DateTime.now().setZone(tz);
    const start = DateTime.fromISO(startStr, { zone: tz });
    const end = DateTime.fromISO(endStr, { zone: tz });
    if (start.isValid && end.isValid) {
      if (now >= start && now < end) {
        slideBlock.style.display = 'block';
        visible = true;
      } else {
        slideBlock.style.display = 'none';
      }
    } else {
      console.warn('Invalid start or end time');
      slideBlock.style.display = 'none';
    }
  });
  return visible;
}

// back in stock
document.addEventListener('DOMContentLoaded', () => {
  const bisContainer = document.getElementById('bis-container');
  if (!bisContainer) return;

  const bisButton = document.getElementById('bis-trigger-button');
  const modal = document.getElementById('bis-modal');
  const close = document.getElementById('bis-close');
  const form = document.getElementById('klaviyo-back-in-stock-form');
  const message = document.getElementById('bis-message');
  const emailInput = document.getElementById('bis-email');

  const bisEnabled = bisContainer.dataset.bisEnabled === 'true';
  if (!bisEnabled) return;

  // 解析 variants
  let variants = [];
  try {
    variants = JSON.parse(bisContainer.dataset.variants || '[]');
  } catch (err) {
    console.warn('[BIS] parse variants failed', err);
    variants = [];
  }

  // 根据 id 查找 variant
  function findVariantById(id) {
    if (!id) return null;
    const sid = String(id);
    return variants.find(v => String(v.id) === sid) || null;
  }

  // 获取当前选中变体 id
  function getSelectedVariantId() {
    // 0. URL 参数 (?variant=xxxx)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) return urlParams.get('variant');

    // 1. ShopifyAnalytics.meta.selectedVariantId（需校验一致性）
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      const id = String(window.ShopifyAnalytics.meta.selectedVariantId);
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input || input.value === id) return id;
    }

    // 2. form select / input[name="id"]
    const cartForm = document.querySelector('form[action*="/cart/add"]');
    if (cartForm) {
      const select = cartForm.querySelector('select[name="id"]');
      if (select?.value) return String(select.value);
      const input = cartForm.querySelector('input[name="id"]');
      if (input?.value) return String(input.value);
    }

    // 3. bisContainer 初始数据
    if (bisContainer?.dataset.initialVariantId) return String(bisContainer.dataset.initialVariantId);

    // 4. window.meta / product.variants fallback
    if (variants.length) return String(variants[0].id);

    return null;
  }

  // 更新 BIS 按钮是否显示：如果当前选中变体缺货则显示
  function updateBisVisibility(variantId) {
    // 如果没传入 id，则尝试重新读
    const vid = variantId ? String(variantId) : getSelectedVariantId();
    const variant = findVariantById(vid);
    console.log('🍎🍎🍎[BIS] updateBisVisibility', vid, variant);

    // case A: 找到对应变体 —— 按该变体的 available 决定
    if (variant) {
      if (variant.hasOwnProperty('available')) {
        if (variant.available === false) {
          bisContainer.hidden = false;
        } else {
          bisContainer.hidden = true;
          if (modal) modal.style.display = 'none';
        }
        return;
      }
    }

    // case B: 未找到指定变体 —— 如果是单变体商品，用第一个变体的 available 决定
    if (variants.length === 1) {
      const first = variants[0];
      if (first && first.available === false) {
        bisContainer.hidden = false;
        return;
      }
    }

    // 默认：隐藏
    bisContainer.hidden = true;
    if (modal) modal.style.display = 'none';
  }

  // 初次加载判断一次
  updateBisVisibility();

  // 监听变体改变
  if (typeof subscribe === 'function') {
    subscribe('variant-change', (event) => {
      const variant = event?.data?.variant;
      if (!variant) {
        updateBisVisibility();
        return;
      }
      updateBisVisibility(variant.id);
    });
  } else {
    // 监听表单里的 select/input 变化
    const cartForm = document.querySelector('form[action*="/cart/add"]');
    if (cartForm) {
      cartForm.addEventListener('change', () => {
        // 读取 select/input 的当前值
        const select = cartForm.querySelector('select[name="id"]');
        const input = cartForm.querySelector('input[name="id"]');
        const v = (select && select.value) || (input && input.value);
        updateBisVisibility(v);
      });
    }
  }

  // 弹窗控制
  bisButton?.addEventListener('click', () => {
    if (modal) modal.style.display = 'flex';
  });
  close?.addEventListener('click', () => {
    if (modal) modal.style.display = 'none';
  });
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) modal.style.display = 'none';
  });

  // 表单提交
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = (emailInput && emailInput.value || '').trim();
    if (!email) {
      alert('Please enter your email.');
      return;
    }

    const selectedId = getSelectedVariantId();
    if (!selectedId) {
      alert('Variant not found. Please try again.');
      return;
    }

    const klaviyoVariantId = `$shopify:::$default:::${selectedId}`;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: klaviyoVariantId },
          },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoApiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        message.style.display = 'block';
        form.reset();
        setTimeout(() => {
          message.style.display = 'none';
          if (modal) modal.style.display = 'none';
        }, 1600);
      } else {
        const err = await response.json();
        console.error('Klaviyo error:', err);
        alert('Subscription failed, please try again.');
      }
    } catch (err) {
      console.error(err);
      alert('Network error, please try again later.');
    }
  });
});

/**
 * 生成下拉框选项（配镜使用）
 * @param {string|HTMLElement} selectElement - select 的 DOM 或 ID
 * @param {number} min - 最小值
 * @param {number} max - 最大值
 * @param {number} step - 步长
 * @param {number} decimals - 小数位数
 * @param {number|string|null} defaultValue - 默认选中值
 * @param {boolean} addPlusSign - 正数是否添加 "+"
 */
function populateSelect(selectElement, min, max, step, decimals = 2, defaultValue = null, addPlusSign = false) {
  const select = typeof selectElement === 'string'
    ? document.getElementById(selectElement)
    : selectElement;

  if (!select) return;

  select.innerHTML = ''; // 清空

  for (let value = min; value <= max + 0.00001; value += step) {
    let formattedValue = value.toFixed(decimals);

    // 对于正数加上"+"号
    if (addPlusSign && formattedValue > 0) {
      formattedValue = `+${formattedValue}`;
    }

    const option = document.createElement('option');
    option.value = formattedValue;
    option.textContent = formattedValue;
    if (defaultValue !== null && Number(formattedValue) === Number(defaultValue)) {
      option.selected = true;
      select.dataset.default = formattedValue;
    }

    select.appendChild(option);
  }
}